import { defineMessages } from 'react-intl';

export default defineMessages({
  title_suivre_sinistre: {
    id: 'dashboard_auto.title_suivre_sinistre',
  },
  title_declarer_sinistre: {
    id: 'dashboard_auto.title_declarer_sinistre',
  },
  title_contracts_garanties: {
    id: 'dashboard_auto.title_contracts_garanties',
  },
  title_ajout_contrat: {
    id: 'dashboard_auto.title_ajout_contrat',
  },
  title_offres_conseils: {
    id: 'dashboard_auto.offres_conseils_title',
  },
  buttonLabel_offre1: {
    id: 'dashboard_auto.offres_conseils_offre1_button',
  },
  buttonLabel_offre2: {
    id: 'dashboard_auto.offres_conseils_offre2_button',
  },
  buttonLabel_offre3: {
    id: 'dashboard_auto.offres_conseils_offre3_button',
  },
  buttonLabel_make_estimate: {
    id: 'dashboard_auto.offres_conseils_estimate_button',
  },
  buttonLabel_offre4: {
    id: 'dashboard_auto.offres_conseils_offre4_button',
  },
  declarer_Sinistre: {
    id: 'dashboard_mrh.que_faire_en_cas_sinistre',
  },
  declarer_Sinistre_title: {
    id: 'dashboard_auto.declarer_sinistre_title',
  },
  declarer_Sinistre_description: {
    id: 'dashboard_auto.declarer_sinistre_description',
  },
  contactAgentService: {
    id: 'dashboard_auto.contact_service',
  },
  contactAgent: {
    id: 'dashboard_auto.contact_agent_numero',
  },
  contactEmail: {
    id: 'dashboard_auto.contact_email',
  },
  close: {
    id: 'modal.close',
  },
  renewAutoTitle: {
    id: 'offer.advice.renewAuto.title',
  },
  newBusinessTitle: { id: 'offer.advice.newBusiness.title' },
  offerMRHTitle: { id: 'offer.advice.offerMRH.title' },
  ADETitle: { id: 'offer.advice.ADE.title' },
  renewAutoContent: {
    id: 'offer.advice.renewAuto.content',
  },
  newBusinessContent: { id: 'offer.advice.newBusiness.content' },
  offerMRHContent: { id: 'offer.advice.offerMRH.content' },
  ADEContent: { id: 'offer.advice.ADE.content' },
});
